import { arrayOf, object, shape, string } from './type-checkers';

const validators = shape({
  name: string,
  options: object,
}).type('validators');

export default arrayOf(validators).type('list').group('validations');
